import { Layout } from '@msanvarov/core-components';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import ShiningStar from '../../../../../libs/core-components/src/lib/layout/ShiningStar';
import ShootingStar from '../../../../../libs/core-components/src/lib/layout/ShootingStar';

const ExpenseTrackerSecurityPage = () => {
  const router = useRouter();
  const [countdown, setCountdown] = useState(5);
  const [isRedirecting, setIsRedirecting] = useState(false);

  // VirusTotal link for the app analysis
  const virusTotalLink =
    'https://www.virustotal.com/gui/file/6d435945ef88765f46a4c281bd1fd93344fcf1e5b36098c1eea4b05976ba29ab';

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          setIsRedirecting(true);
          // Redirect to VirusTotal
          window.location.href = virusTotalLink;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleManualRedirect = () => {
    setIsRedirecting(true);
    window.location.href = virusTotalLink;
  };

  return (
    <Layout
      wrapperClass="main-aboutpage"
      title="Expense Tracker - Security Report"
    >
      <section className="contact-area">
        <div className="container">
          <div className="about-details" data-aos="zoom-in">
            <h1 className="section-heading" data-aos="fade-up">
              <img src="/assets/star-2.png" alt="Star" />
              Security Report
              <img src="/assets/star-2.png" alt="Star" />
            </h1>
            <br />
          </div>

          <div
            className="main-security-container shadow-box"
            data-aos="zoom-in"
          >
            <ShiningStar />
            <ShootingStar />

            {/* Header Section */}
            <div className="security-header-section">
              <div className="security-shield">
                <i className="iconoir-shield-check" />
              </div>
              <div className="header-content">
                <h1><i className="iconoir-lock" /> Expense Tracker Security Analysis</h1>
                <div className="scan-badge">
                  <span className="scan-status"><i className="iconoir-check-circle" /> VERIFIED SAFE</span>
                  <p>Last Scanned: August 18, 2025</p>
                </div>
                <p className="security-intro">
                  Your security and privacy are our top priorities. This app has
                  been thoroughly tested and verified to be 100% safe and secure
                  by multiple security engines.
                </p>
              </div>
            </div>

            {/* Main Content Layout */}
            <div className="security-content-grid">
              {/* Left Column - Security Details */}
              <div className="security-left">
                {/* Quick Security Overview */}
                <div className="security-overview">
                  <h3><i className="iconoir-shield-check" /> Security Verification</h3>
                  <div className="verification-grid">
                    <div className="verify-item">
                      <div className="verify-icon"><i className="iconoir-shield-check" /></div>
                      <div className="verify-content">
                        <h4>Malware Scan</h4>
                        <span className="status-safe">
                          Clean - No threats detected
                        </span>
                      </div>
                    </div>
                    <div className="verify-item">
                      <div className="verify-icon"><i className="iconoir-search" /></div>
                      <div className="verify-content">
                        <h4>Code Analysis</h4>
                        <span className="status-safe">
                          Verified - No suspicious behavior
                        </span>
                      </div>
                    </div>
                    <div className="verify-item">
                      <div className="verify-icon"><i className="iconoir-lock" /></div>
                      <div className="verify-content">
                        <h4>Privacy Check</h4>
                        <span className="status-safe">
                          Secure - Your data stays private
                        </span>
                      </div>
                    </div>
                    <div className="verify-item">
                      <div className="verify-icon"><i className="iconoir-smartphone" /></div>
                      <div className="verify-content">
                        <h4>Permissions</h4>
                        <span className="status-safe">
                          Minimal - Only necessary permissions
                        </span>
                      </div>
                    </div>
                    <div className="verify-item">
                      <div className="verify-icon"><i className="iconoir-refresh-double" /></div>
                      <div className="verify-content">
                        <h4>Data Encryption</h4>
                        <span className="status-safe">
                          Bank-level encryption enabled
                        </span>
                      </div>
                    </div>
                    <div className="verify-item">
                      <div className="verify-icon"><i className="iconoir-graph-up" /></div>
                      <div className="verify-content">
                        <h4>Scan Engines</h4>
                        <span className="status-safe">
                          Verified by 70+ antivirus engines
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* About App Section */}
                <div className="app-info-section">
                  <h3><i className="iconoir-wallet" /> About Expense Tracker</h3>
                  <p>
                    This app helps you split expenses with friends, track loans,
                    and manage group finances effortlessly. Perfect for
                    roommates, travel groups, couples, and students who need to
                    manage shared expenses.
                  </p>
                  <div className="app-features-tags">
                    <span className="feature-tag">
                      Room-Based Organization
                    </span>
                    <span className="feature-tag">
                      Smart Expense Splitting
                    </span>
                    <span className="feature-tag">Real-Time Sync</span>
                    <span className="feature-tag">Balance Overview</span>
                  </div>
                </div>

                {/* Detailed Security Summary */}
                <div className="detailed-security">
                  <h3><i className="iconoir-clipboard-check" /> Complete Security Summary</h3>
                  <div className="security-checklist">
                    <div className="check-item">
                      <span className="check-icon"><i className="iconoir-check-circle" /></span>
                      <span>
                        Scanned by 70+ antivirus engines on August 18, 2025
                      </span>
                    </div>
                    <div className="check-item">
                      <span className="check-icon"><i className="iconoir-check-circle" /></span>
                      <span>No malicious code or viruses detected</span>
                    </div>
                    <div className="check-item">
                      <span className="check-icon"><i className="iconoir-check-circle" /></span>
                      <span>
                        No network communication to suspicious domains
                      </span>
                    </div>
                    <div className="check-item">
                      <span className="check-icon"><i className="iconoir-check-circle" /></span>
                      <span>No unauthorized data access or collection</span>
                    </div>
                    <div className="check-item">
                      <span className="check-icon"><i className="iconoir-check-circle" /></span>
                      <span>Signed with valid digital certificate</span>
                    </div>
                    <div className="check-item">
                      <span className="check-icon"><i className="iconoir-check-circle" /></span>
                      <span>
                        Bank-level encryption for all data transmission
                      </span>
                    </div>
                    <div className="check-item">
                      <span className="check-icon"><i className="iconoir-check-circle" /></span>
                      <span>Secure cloud backup with encryption</span>
                    </div>
                    <div className="check-item">
                      <span className="check-icon"><i className="iconoir-check-circle" /></span>
                      <span>No ads or third-party data selling</span>
                    </div>
                    <div className="check-item">
                      <span className="check-icon"><i className="iconoir-check-circle" /></span>
                      <span>Regular security updates and monitoring</span>
                    </div>
                    <div className="check-item">
                      <span className="check-icon"><i className="iconoir-check-circle" /></span>
                      <span>
                        Your financial information stays completely private
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column - VirusTotal Redirect */}
              <div className="security-right">
                <div className="virustotal-section">
                  <div className="virustotal-header">
                    <h3>� Detailed Security Analysis</h3>
                    <p>View comprehensive security analysis on VirusTotal</p>
                  </div>

                  <div className="countdown-section">
                    {!isRedirecting ? (
                      <>
                        <div className="countdown-display">
                          <div className="countdown-circle">
                            <span className="countdown-number">
                              {countdown}
                            </span>
                          </div>
                          <h4>Redirecting to VirusTotal...</h4>
                          <p>You will be redirected in {countdown} seconds</p>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="loading-display">
                          <div className="loading-spinner"></div>
                          <h4>Redirecting...</h4>
                          <p>Taking you to the security analysis...</p>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="action-buttons">
                    <button
                      className="virustotal-btn"
                      onClick={handleManualRedirect}
                      disabled={isRedirecting}
                    >
                      <i className="iconoir-external-link" />
                      View on VirusTotal Now
                    </button>

                    <button className="back-btn" onClick={() => router.back()}>
                      <i className="iconoir-arrow-left" />
                      Go Back to Download
                    </button>
                  </div>

                  <div className="virustotal-info">
                    <h4>About VirusTotal</h4>
                    <p>
                      VirusTotal is a free online service owned by Google that
                      analyzes files and URLs for viruses, worms, trojans and
                      other malicious content using 70+ antivirus engines and
                      website scanners. It's the industry standard for file
                      security verification.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .main-security-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 40px;
          border-radius: 24px;
          position: relative;
          backdrop-filter: blur(15px);
          border: 1px solid rgba(255, 255, 255, 0.15);
          background: rgba(0, 0, 0, 0.3);
        }

        .security-header-section {
          display: flex;
          align-items: center;
          gap: 32px;
          margin-bottom: 40px;
          padding-bottom: 32px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .security-shield {
          flex-shrink: 0;
          width: 120px;
          height: 120px;
          background: radial-gradient(
            circle,
            rgba(0, 255, 0, 0.2),
            rgba(0, 255, 0, 0.05)
          );
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid rgba(0, 255, 0, 0.3);
        }

        .security-shield i {
          font-size: 64px;
          color: #00ff00;
          filter: drop-shadow(0 0 20px rgba(0, 255, 0, 0.5));
        }

        .header-content {
          flex: 1;
        }

        .header-content h1 {
          font-size: 32px;
          font-weight: 800;
          margin: 0 0 16px 0;
          color: var(--primary_color);
          background: linear-gradient(135deg, var(--primary_color), #00ff88);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .scan-badge {
          margin-bottom: 16px;
        }

        .scan-status {
          display: inline-block;
          background: linear-gradient(135deg, #00ff00, #00cc00);
          color: #000;
          padding: 8px 20px;
          border-radius: 25px;
          font-weight: 800;
          font-size: 14px;
          letter-spacing: 0.5px;
          box-shadow: 0 4px 15px rgba(0, 255, 0, 0.3);
        }

        .scan-badge p {
          margin: 8px 0 0 0;
          color: #00ff00;
          font-weight: 600;
          font-size: 14px;
        }

        .security-intro {
          font-size: 16px;
          line-height: 1.6;
          color: var(--text_color);
          opacity: 0.9;
          margin: 0;
        }

        .security-content-grid {
          display: grid;
          grid-template-columns: 1fr 400px;
          gap: 40px;
        }

        .security-left {
          display: flex;
          flex-direction: column;
          gap: 32px;
        }

        .security-overview h3 {
          font-size: 24px;
          color: var(--primary_color);
          margin-bottom: 24px;
          font-weight: 700;
        }

        .verification-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 16px;
        }

        .verify-item {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 12px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          transition: all 0.3s ease;
        }

        .verify-item:hover {
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(0, 255, 0, 0.3);
          transform: translateY(-2px);
        }

        .verify-icon {
          font-size: 24px;
          flex-shrink: 0;
        }

        .verify-content h4 {
          margin: 0 0 4px 0;
          font-size: 14px;
          font-weight: 600;
          color: var(--text_color);
        }

        .status-safe {
          color: #00ff00;
          font-weight: 700;
          font-size: 12px;
        }

        .app-info-section {
          padding: 24px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 16px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .app-info-section h3 {
          font-size: 20px;
          color: var(--primary_color);
          margin-bottom: 16px;
          font-weight: 700;
        }

        .app-info-section p {
          line-height: 1.6;
          margin-bottom: 20px;
          opacity: 0.9;
        }

        .app-features-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }

        .feature-tag {
          background: rgba(0, 100, 255, 0.2);
          color: var(--primary_color);
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          border: 1px solid rgba(0, 100, 255, 0.3);
        }

        .detailed-security h3 {
          font-size: 20px;
          color: var(--primary_color);
          margin-bottom: 20px;
          font-weight: 700;
        }

        .security-checklist {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .check-item {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 12px 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        }

        .check-item:last-child {
          border-bottom: none;
        }

        .check-icon {
          color: #00ff00;
          font-weight: bold;
          flex-shrink: 0;
          font-size: 14px;
        }

        .check-item span:last-child {
          font-size: 14px;
          line-height: 1.4;
          opacity: 0.9;
        }

        .security-right {
          position: sticky;
          top: 20px;
          height: fit-content;
        }

        .virustotal-section {
          padding: 32px;
          background: rgba(0, 100, 255, 0.1);
          border-radius: 20px;
          border: 1px solid rgba(0, 100, 255, 0.2);
          backdrop-filter: blur(10px);
        }

        .virustotal-header {
          text-align: center;
          margin-bottom: 32px;
        }

        .virustotal-header h3 {
          font-size: 24px;
          color: var(--primary_color);
          margin-bottom: 8px;
          font-weight: 700;
        }

        .virustotal-header p {
          opacity: 0.9;
          margin: 0;
        }

        .countdown-section {
          margin-bottom: 32px;
        }

        .countdown-display,
        .loading-display {
          text-align: center;
        }

        .countdown-circle {
          width: 100px;
          height: 100px;
          border: 4px solid var(--primary_color);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          animation: pulse 2s infinite;
          background: rgba(0, 100, 255, 0.1);
        }

        .countdown-number {
          font-size: 36px;
          font-weight: 800;
          color: var(--primary_color);
        }

        .countdown-display h4,
        .loading-display h4 {
          margin: 0 0 8px 0;
          color: var(--primary_color);
          font-weight: 600;
        }

        .countdown-display p,
        .loading-display p {
          margin: 0;
          opacity: 0.8;
          font-size: 14px;
        }

        .loading-spinner {
          width: 50px;
          height: 50px;
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-top: 4px solid var(--primary_color);
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 20px;
        }

        .action-buttons {
          display: flex;
          flex-direction: column;
          gap: 16px;
          margin-bottom: 32px;
        }

        .virustotal-btn {
          width: 100%;
          padding: 16px 24px;
          background: linear-gradient(135deg, var(--primary_color), #0066ff);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          box-shadow: 0 8px 25px rgba(0, 100, 255, 0.3);
        }

        .virustotal-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 12px 35px rgba(0, 100, 255, 0.4);
        }

        .virustotal-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .back-btn {
          width: 100%;
          padding: 12px 24px;
          background: transparent;
          border: 2px solid var(--primary_color);
          color: var(--primary_color);
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .back-btn:hover {
          background: var(--primary_color);
          color: white;
          transform: translateY(-1px);
        }

        .virustotal-info {
          padding: 20px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 12px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .virustotal-info h4 {
          color: var(--primary_color);
          margin: 0 0 12px 0;
          font-weight: 600;
        }

        .virustotal-info p {
          margin: 0;
          font-size: 13px;
          line-height: 1.5;
          opacity: 0.8;
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(0, 100, 255, 0.4);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 0 0 10px rgba(0, 100, 255, 0);
          }
          100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(0, 100, 255, 0);
          }
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @media (max-width: 1024px) {
          .security-content-grid {
            grid-template-columns: 1fr;
            gap: 32px;
          }

          .security-right {
            position: static;
          }

          .security-header-section {
            flex-direction: column;
            text-align: center;
            gap: 20px;
          }

          .verification-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 768px) {
          .main-security-container {
            padding: 24px;
          }

          .header-content h1 {
            font-size: 24px;
          }

          .security-shield {
            width: 80px;
            height: 80px;
          }

          .security-shield i {
            font-size: 48px;
          }

          .verification-grid {
            grid-template-columns: 1fr;
          }

          .app-features-tags {
            justify-content: center;
          }
        }
      `}</style>
    </Layout>
  );
};

export default ExpenseTrackerSecurityPage;
